import {
  Component,
  ComponentFactoryResolver,
  ComponentRef,
  Input,
  OnInit,
  ViewContainerRef,
} from "@angular/core";
import {
  cacheReadyOperator,
  FlowNodeController,
} from "../../flow-node.controller";
import { FlowsService } from "../../flows.service";
import { Router } from "@angular/router";
import { FacilityDTO } from "src/app/facilities/Facility";
import { forkJoin } from "rxjs";
import { UiService } from "src/app/ui/ui.service";
import { MatDialog } from "@angular/material/dialog";
import { StarterNodeMenuComponent } from "./starter-node-menu/starter-node-menu.component";
import { takeUntil } from "rxjs/operators";

@Component({
  selector: "app-starter-node",
  templateUrl: "./starter-node.component.html",
  styleUrls: ["./starter-node.component.scss"],
})
export class StarterNodeComponent extends FlowNodeController implements OnInit {
  menuComponent?: ComponentRef<StarterNodeMenuComponent>;

  constructor(
    factoryResolver: ComponentFactoryResolver,
    ViewContainerRef: ViewContainerRef,
    FlowsService: FlowsService,
    Router: Router,
    uiService: UiService,
    MatDialog: MatDialog,
  ) {
    super(
      factoryResolver,
      ViewContainerRef,
      FlowsService,
      Router,
      uiService,
      MatDialog,
    );
    this.noTopEndpoint = true;
  }

  async ngOnInit(): Promise<void> {
    //console.log('STARTER NODE INIT')
    super.ngOnInit();
    forkJoin([
      this.FlowsService.starterCacheReady.pipe(cacheReadyOperator()),
    ])
      .pipe(takeUntil(this.onComponentDestroy))
      .subscribe(() => {
        const factory = this.factoryResolver.resolveComponentFactory(
          StarterNodeMenuComponent,
        );
        this.menuComponent = factory.create(
          this.flowMenuViewContainerRef.parentInjector,
        );
        this.menuComponent.instance.node = this.node;
        this.menuComponent.instance.internal = this.internal;
        this.menuComponent.instance.selected = this.selected;
        this.menuComponent.instance.facilities = this.facilities;
        this.menuComponent.instance.onMenuSizeChange = this.onMenuSizeChange;
        this.flowMenuViewContainerRef.insert(this.menuComponent.hostView);
        this.menuComponent.instance.onNodeMenuInstantiated
          .pipe(takeUntil(this.onComponentDestroy))
          .subscribe(() => {
            //console.log('STARTER NODE MENU READY')
            this.onMenuInstantiated.next();
            this.onMenuInstantiated.complete();
            this.onNodeReady.emit(this.componentRef);
          });
      });

    this.FlowsService.initStarterNodeCache();
  }

  ngAfterViewInit() {
    super.ngAfterViewInit();
  }

  ngOnDestroy() {
    super.ngOnDestroy();
  }

  get flowDTO() {
    return this.menuComponent?.instance.flowDTO;
  }

  public get entryEventType() {
    return this.menuComponent?.instance.entryEventType;
  }

}
